import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { TrainingService } from '../../../../_services';
import { Transition } from '@uirouter/angular';

@Component({
    selector: 'training-details-details',
    template: ``,
    providers: [TranslatePipe],
})
export class TrainingDetailDetailComponent implements OnInit {
    @Input() training;
    universes: any;
    partners: any;
    success: boolean = false;

    constructor(
        private trainingService: TrainingService,
        private transition: Transition
    ) {}

    ngOnInit(): void {
        this.trainingService
            .findTrainingFull(this.training.id)
            .subscribe((training) => {
                this.training = training;
                this.training.price /= 100;
                this.trainingService.getUniverses().subscribe((universes) => {
                    this.universes = universes;
                });
                this.trainingService.getPartners().subscribe((partners) => {
                    this.partners = partners;
                });
            });
    }

    load(id) {}

    save(): void {
        const training = JSON.parse(JSON.stringify(this.training));
        training.price *= 100;

        this.trainingService
            .updateFullTraining(training)
            .subscribe((response) => {
                if (response !== null) {
                    this.success = true;
                    window.setTimeout(() => {
                        window.scrollTo(0, document.body.scrollHeight);
                    }, 0);
                    window.setTimeout(() => {
                        window.location.reload();
                    }, 1542);
                }
            });
    }

    getBoolTranslateKey(data: any): string {
        if (data) {
            return 'global.true';
        }
        return 'global.false';
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/detail/training-detail-detail.component.ts